module.exports = "/_next/static/images/medicspot-certification-logo-c96301b7da54b329f60c0de4bbc7d67f.jpg.webp";